import { HIDE_ALERTR, SHOW_ALERTR } from "../types"

const handlers = {
    [SHOW_ALERTR]: (state, {payload}) => ({...payload, visible: true}),
    [HIDE_ALERTR]: state => ({...state, visible: false}),
    DEFAULT: state => state,
}


export const alertReducer = (state, action) => {
    const handle = handlers[action.type] || handlers.DEFAULT
    return handle(state, action)
}